module.exports = __webpack_public_path__ + "static/media/symbols.eef9de01.svg";